export const assignmentDeleteToastCss = {
  marginTop: "16px",
};
